import { Heading2, Paragraph } from "../../../../src/components/Markdown";
import * as React from 'react';
export default {
  Heading2,
  Paragraph,
  React
};